import { SocialItem } from 'src/global/types/common.type';

export interface SocialProps extends SocialItem {
  className?: string;
}

const Social = ({ href, src, alt, className }: SocialProps) => {
  return (
    <a href={href} target={'_blank'} style={{ lineHeight: 0 }}>
      <img alt={alt} height={32} width={32} src={src} className={className} />
    </a>
  );
};

export default Social;
